import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core';
import MainButton from '@configuratorware/configurator-frontendgui/Shared/Components/MainButton';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import {
  applyOptionInputText,
  selectOptionclassification,
} from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions';
import { removeHiddenComponents } from '../../Reducers/Configurator/Selectors';

const getNextAvailableComponent = (visibleComponents, currentComponent) => {
  let i = visibleComponents.findIndex(({ identifier }) => identifier === currentComponent.identifier) + 1;
  while (visibleComponents[i]) {
    if (!visibleComponents[i].disabled) {
      return visibleComponents[i];
    }
    i++;
  }
};

const isNextDisabled = ({ configurator }) => {
  const { selectedoptionclassification: currentComponent, configuration } = configurator;
  return (
    currentComponent?.identifier === 'door_types' &&
    currentComponent.selectedoptions[0]?.identifier !== 'no_door' &&
    !configuration.customdata?.doors?.length
  );
};

const useStyles = makeStyles({
  root: {
    marginTop: 16,
    marginBottom: 16,
  },
});

const NextComponentButton = () => {
  const { selectedoptionclassification: currentComponent, filteredOptionclassifications: components } =
    useSelector((state) => state.configurator);
  const visibleComponents = removeHiddenComponents(components);
  const nextComponent = getNextAvailableComponent(visibleComponents, currentComponent);

  const disabled = useSelector(isNextDisabled);

  const dispatch = useDispatch();
  const onClickNext = () => {
    dispatch(applyOptionInputText(currentComponent));
    dispatch(selectOptionclassification(nextComponent, true, true));
  };
  const classes = useStyles();
  if (!nextComponent) {
    return null;
  }
  return (
    <MainButton
      variant="contained"
      fullWidth
      size="medium"
      onClick={onClickNext}
      classes={classes}
      disabled={disabled}
    >
      {t('optionList.next')}
    </MainButton>
  );
};

export default NextComponentButton;
